(function () {
    'use strict';

    angular.module("imApp").factory("printArgService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1508,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
